import axiosInstance from '../api/axios';

interface IBody {
  course: string;
  program: string;
}

export async function markLessonFinish(slug: string, body: IBody | null) {
  const response = await axiosInstance.post(`/lessons/${slug}/finished`, body);
  return response.data;
}

export async function getLessonCore(slug: string) {
  try {
    const response = await axiosInstance.get(`/lessons/${slug}`)

    return response.data
  } catch(e: any) {
    throw new Error(e);
  }
}


